// Deltek VantagePoint deep links for project role groups.
//
// A confidential-project role is named Role_<REGION>_Project_Contributor_<projectNumber>
// (see ProvisionProject, which creates them). VantagePoint identifies the same project by
// a number that always carries a leading region letter: ANZ project numbers already
// include theirs (149585.00), US ones don't (26523.10 → U26523.10). Anything that isn't a
// project role — Role_IT_Admin, say — has no project to link to.
const PROJECT_ROLE =
  /^Role_(?<region>[A-Za-z]+)_Project_Contributor_(?<projectNumber>[A-Za-z0-9]+\.[A-Za-z0-9]+)$/;

// Region letter VantagePoint expects in front of the role name's project number. Regions
// whose numbers already carry theirs (ANZ) aren't listed and are used as-is, which is also
// the fallback for any region the tool doesn't yet provision.
const REGION_PREFIX: Record<string, string> = { US: 'U' };

// The VantagePoint project number for a role display name, or undefined when the name
// isn't a project role.
export const vantagePointProjectNumber = (displayName: string) => {
  const groups = PROJECT_ROLE.exec(displayName)?.groups;
  if (!groups) return undefined;
  const prefix = REGION_PREFIX[groups.region.toUpperCase()] ?? '';
  return `${prefix}${groups.projectNumber}`;
};

// Deep link to the project's overview in VantagePoint, or undefined when the role isn't a
// project role (RoleInfo then shows no VantagePoint link).
export const vantagePointProjectUrl = (displayName: string) => {
  const projectNumber = vantagePointProjectNumber(displayName);
  return projectNumber
    ? `https://vantagepoint.holmesgroup.com/Vantagepoint/app/#!Projects/view/project/0/${encodeURIComponent(projectNumber)}/hybrid`
    : undefined;
};
